export default {"src":"/_next/static/media/notifications.colour.7d1e0e03.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};